// Hooks / Node modules / Styles
import classNames from "classnames";
import { useNavigate } from "react-router-dom";
import { Brand } from "elseware-ui";

// Reducers / Actions

// Utils / Functions

// Components

// Sub-Components

// Data / Images / Icons

function CustomBrand() {
  const navigate = useNavigate();

  return (
    <div
      onClick={() => navigate("/")}
      className="font-semibold text-xl text-gray-600 hover:cursor-pointer"
    >
      Portfolio
    </div>
  );
}

export default CustomBrand;
